import {
    CUSTOMER_CUSTOM_IMAGES_KEY,
    customerCustomImages,
    isCustomerUnAuthorized,
} from '../helpers/utils'
import { nextAPI } from './Axios'
import { UserFileUploadAPI } from './UserFileUploadAPI'
import { FileAPI } from './FileAPI'
import { UserUploadStore } from '../state/UserUploadStore'
import { UserStore } from '../state/UserStore'

export const CustomerFetcher = async (url) => {
    try {
        const response = await nextAPI.get(url)
        // Ensure the response is OK
        if (response.status === 200) {
            return response.data.data
        } else {
            // You can throw an error for any status code you deem to be an error state
            const error = new Error('Error fetching data')
            error.status = response.status
            throw error
        }
    } catch (error) {
        // Check if the error is a 401 - Unauthorized
        if (error.response && error.response.status === 401) {
            // Handle the 401 error (e.g., redirect to login, set error state, etc.)
            // Example: Redirect to login page
            // window.location.href = '/login'

            // Return something specific to your component to understand there was an auth issue
            // return { unauthorized: true }
            return { unauthorized: true }
            // throw error
        }
        // Re-throw the error for any other error types or if you want to handle it in your component
        throw error
    }
}

export const OrdersFetcher = async (url) => {
    try {
        const response = await nextAPI.get(url)
        if (response.status === 200) {
            return { data: response.data.data, headers: response.data.headers }
        } else {
            // Handle other status codes as needed
            const error = new Error('Error fetching orders')
            error.status = response.status
            throw error
        }
    } catch (error) {
        // Handle 401 Unauthorized error
        if (error.response && error.response.status === 401) {
            // For instance, redirect to a login page or return an unauthorized flag
            // window.location.href = '/login';
            // return { unauthorized: true }
            return { data: [], headers: {} }
        }
        // For any other errors, rethrow it
        throw error
    }
}

export const CustomerAPI = {
    getCustomer: 'my-account?requestURL=customer',
    getOrdersByCustomer: 'my-account?requestURL=orders',
    getSubscriptionsByCustomer: 'my-account?requestURL=subscriptions',
    getScannedBarcodes: 'my-account?requestURL=scannedBarcodes',
    scanBarcode: 'my-account?requestURL=scanBarcode',
    getRmsHistory: 'my-account?requestURL=userRmsHistory',
    getCredits: 'my-account?requestURL=credits',

    // getOrdersByCustomer(id) {
    //     // We will fetch this much, so we can implement pagination ourselves
    //     const url = `orders/?customer=${id}&per_page=100`
    //     return nextAPI.get('my-account', {
    //         url,
    //     })
    // },
}

export const SaveCustomerAPI = {
    save(data) {
        return nextAPI.post('my-account?requestURL=saveCustomer', data)
    },
    updatePassword(data) {
        return nextAPI.post('my-account?requestURL=updatePassword', data)
    },
    cancelSubscription(data) {
        return nextAPI.post('my-account?requestURL=cancelSubscription', data)
    },

    async deleteImage(customer, url) {
        let filteredImgaes = customerCustomImages(customer).filter((item) => {
            return item.url !== url
        })

        const payload = {
            meta_data: [
                {
                    key: CUSTOMER_CUSTOM_IMAGES_KEY,
                    value: [...filteredImgaes],
                },
            ],
        }

        await FileAPI.deleteCustomUpload(url)
        return nextAPI.post('my-account?requestURL=saveCustomer', payload)
    },

    async addCustomUploads(customer, images) {
        const meta_data = []

        images.forEach((image) => {
            meta_data.push({
                url: image.url,
                name: image.name,
                upload_time: new Date().toUTCString(),
            })
        })

        const payload = {
            meta_data: [
                {
                    key: CUSTOMER_CUSTOM_IMAGES_KEY,
                    value: [...meta_data, ...customerCustomImages(customer)],
                },
            ],
        }
        return await nextAPI.post('my-account?requestURL=saveCustomer', payload)
    },

    async addCustomUploadsFromLocalStore(customer = null) {
        if (!customer) {
            customer = UserStore.getState().user.customer
        }
        const uploads = UserUploadStore.getState().uploads
        if (!uploads?.length || isCustomerUnAuthorized(customer)) {
            return
        }
        await this.addCustomUploads(customer, uploads)
        UserUploadStore.getState().reset()
    },

    async uploadImages({ customer, data }) {
        const images = data[CUSTOMER_CUSTOM_IMAGES_KEY]

        const UploadedImages = await UserFileUploadAPI.uploadFiles(images, {})

        if (!isCustomerUnAuthorized(customer)) {
            await this.addCustomUploads(customer, UploadedImages)
        }

        return UploadedImages
    },
}

export const getCurrentCustomer = async () => {
    try {
        const { data } = await nextAPI.get(CustomerAPI.getCustomer)
        return data
    } catch (e) {
        return null
    }
}
